import React, { useEffect, useState } from "react";
import { Navigate, Link, Routes, Route } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { ArrowLeft, BookOpen } from "lucide-react";
import KhataHome from "@/components/khata/KhataHome";
import KhataParty from "@/components/khata/KhataParty";
import AdSlider from "@/components/ads/AdSlider";

// Staff (inside AppShell)
export function Ledger() {
  return (
    <div className="space-y-6" data-testid="ledger-page">
      <header>
        <div className="text-[11px] tracking-[0.2em] uppercase text-zinc-500 font-semibold">Firm khata</div>
        <h1 className="font-heading font-black tracking-tight text-3xl sm:text-4xl mt-2 flex items-center gap-3"><BookOpen size={28} strokeWidth={1.75} /> Khata / Ledger</h1>
        <p className="text-sm text-zinc-600 mt-1">Every invoice you raise and payment you receive lands here automatically; add any other credit or expense by hand.</p>
      </header>
      <Routes>
        <Route index element={<KhataHome base="/ledger" />} />
        <Route path=":id" element={<KhataParty base="/ledger" />} />
      </Routes>
    </div>
  );
}

// Client (standalone, like MyBilling)
export default function MyKhata() {
  const { user, logout } = useAuth();
  const [name, setName] = useState("");
  useEffect(() => { if (user?.role === "client") api.get("/khata/summary").then(r => setName(r.data.business_name)).catch(() => {}); }, [user]);
  if (user === null) return <div className="min-h-screen grid place-items-center text-zinc-500 tracking-[0.2em] uppercase text-xs">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "client") return <Navigate to="/ledger" replace />;
  return (
    <div className="min-h-screen bg-zinc-50" data-testid="my-khata">
      <header className="bg-white border-b border-zinc-200">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <Link to="/my-portal" data-testid="khata-back-portal" className="p-2 border border-zinc-200 hover:bg-zinc-900 hover:text-white transition-colors"><ArrowLeft size={14} /></Link>
            <div className="min-w-0"><div className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 font-semibold">My Khata</div><div className="font-heading font-bold tracking-tight truncate">{name || user.name}</div></div>
          </div>
          <div className="flex gap-2">
            <Link to="/my-billing" data-testid="khata-to-billing" className="text-[10px] tracking-[0.14em] uppercase font-semibold px-3 py-1.5 border border-zinc-300 hover:bg-zinc-900 hover:text-white transition-colors">My Billing</Link>
            <button data-testid="khata-signout" onClick={logout} className="text-[10px] tracking-[0.14em] uppercase font-semibold px-3 py-1.5 border border-zinc-300 hover:bg-zinc-900 hover:text-white transition-colors">Sign out</button>
          </div>
        </div>
      </header>
      <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-4 -mb-2"><AdSlider placement="business" slim /></div>
      <main className="max-w-5xl mx-auto px-4 sm:px-6 py-6">
        <Routes>
          <Route index element={<KhataHome base="/my-khata" />} />
          <Route path=":id" element={<KhataParty base="/my-khata" />} />
        </Routes>
      </main>
    </div>
  );
}
